import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuthStore } from '@/stores/authStore'
import { Spinner } from '@/components/ui/spinner'

/**
 * Gate for authenticated routes.
 *
 * Waits for the initial silent refresh before deciding. Without that wait, every reload
 * would briefly redirect to /login before the cookie-based session was restored.
 */
export function RequireAuth() {
  const user = useAuthStore((state) => state.user)
  const initialising = useAuthStore((state) => state.initialising)
  const location = useLocation()

  if (initialising) {
    return (
      <div className="grid min-h-dvh place-items-center">
        <Spinner label="Restoring your session" />
      </div>
    )
  }

  if (!user) {
    // Remember where they were headed so login can send them back there.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }

  return <Outlet />
}
